import * as ambassadorWixIamSignonV1SignOnPolicy from './iam-signon-v1-sign-on-policy-sign-on-policy.http.js';
import * as ambassadorWixIamSignonV1SignOnPolicyTypes from './iam-signon-v1-sign-on-policy-sign-on-policy.types.js';
import * as ambassadorWixIamSignonV1SignOnPolicyUniversalTypes from './iam-signon-v1-sign-on-policy-sign-on-policy.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getSignOnPolicy(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixIamSignonV1SignOnPolicyUniversalTypes.GetSignOnPolicyRequest,
  ambassadorWixIamSignonV1SignOnPolicyTypes.GetSignOnPolicyRequest,
  ambassadorWixIamSignonV1SignOnPolicyUniversalTypes.GetSignOnPolicyResponse,
  ambassadorWixIamSignonV1SignOnPolicyTypes.GetSignOnPolicyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIamSignonV1SignOnPolicy.getSignOnPolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/sign-on-policies',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateSignOnPolicy(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixIamSignonV1SignOnPolicyUniversalTypes.UpdateSignOnPolicyRequest,
  ambassadorWixIamSignonV1SignOnPolicyTypes.UpdateSignOnPolicyRequest,
  ambassadorWixIamSignonV1SignOnPolicyUniversalTypes.UpdateSignOnPolicyResponse,
  ambassadorWixIamSignonV1SignOnPolicyTypes.UpdateSignOnPolicyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIamSignonV1SignOnPolicy.updateSignOnPolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/sign-on-policies',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SignOnPolicy as SignOnPolicyOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  GetSignOnPolicyRequest as GetSignOnPolicyRequestOriginal,
  GetSignOnPolicyResponse as GetSignOnPolicyResponseOriginal,
  UpdateSignOnPolicyRequest as UpdateSignOnPolicyRequestOriginal,
  UpdateSignOnPolicyResponse as UpdateSignOnPolicyResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetSignOnPolicyApplicationErrors as GetSignOnPolicyApplicationErrorsOriginal,
  UpdateSignOnPolicyApplicationErrors as UpdateSignOnPolicyApplicationErrorsOriginal,
} from './iam-signon-v1-sign-on-policy-sign-on-policy.types.js';
